import React, {useEffect, useRef} from "react";
import classNames from "classnames";
import styled from 'styled-components';
import { ICardProps } from ".";
import { getImagePath } from "../../utilities/path";
import { AutomationTestIdFeature, AutomationTestIdElementType, createDataTestId } from "../../utilities/automation";
import Picture from "../Picture";
import { getReplacedContent, parseHTML } from "../../utilities/markdown";

const SolidColorPhotoCardContainer = styled.div`
    border: unset;
    border-radius: 2px;
    background-color: unset;
    height: 395px;
    max-height: 395px;
    max-width: 328px;
    padding: 0;
    overflow: hidden;

    &:hover {
        .card-body img.card-img-top {
            top: 0;
            position: absolute;
        }

        .card-body picture.card-img-top {
            top: 0;
            position: absolute;
        }

        .card-content {
            height: calc(100% - 114px);
        }
    }

    .card-content {
        padding: 1.778rem;
        position: absolute;
        bottom: 0;
        height: 395px;
        max-height: 395px;
        transition: all .25s ease-in-out;

        @media(max-width:576px) {
            height: calc(100% - 114px);
        }
    }

    .card-title {
        line-height: 1.1;
        color: #FFF;
    }

    .card-text {
        font-weight: 400;
        color: #FFF;
    }

    .card-body img.card-img-top {
        border-radius: unset;
        top: -114px;
        height: 114px;
        object-fit: cover;
        transition: all .25s ease-in-out;
        display: flex;
        align-self: start;
        position: absolute;

        @media(max-width:576px) {
            top: 0;
        }
    }

    .card-body {
        padding: 0px;
        pointer-events: none;
        
        .card-body picture.card-img-top {
            top: -114px;
            height: 114px;
            width: 100%;
            position: absolute;
        }
    }

    .footer {
        padding-bottom: 1.778rem;
        padding-left: 1.778rem;
        padding-right: 1.778rem;

        a::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
            pointer-events: auto;
            content: "";
            background-color: rgba(0,0,0,0);
        }
    }

    @media(max-width:576px) { 
        max-width: 100%;
    }

    .btn-outline-light:hover {
        border-color: #FFF !important;
    }
`;

const SolidColorPhotoCard = (props: ICardProps) => {
    const { className, editorClassObj, cmsId, cardTitle, cardBody, cardFooter, cardImage, cardAlt, backgroundColor, children } = props;

    return (
        
        <SolidColorPhotoCardContainer data-id={cmsId} className={classNames(className, editorClassObj, backgroundColor, 'card')}>
                <div className="card-body d-flex flex-column h-100">
                    <Picture
                        loading="lazy"
                        className={"card-img-top"}
                        src={getImagePath(cardImage)}
                        alt={cardAlt}
                        dataTestId={createDataTestId({ feature: AutomationTestIdFeature.CARD_DECK, element: AutomationTestIdElementType.IMAGE, specifier: 'card-image' })}
                    />  
                    <div className="card-content d-flex flex-column">   
                        <h3 className="card-title mb-3" dangerouslySetInnerHTML={{ __html: cardTitle }}></h3>
                        <div className="card-text">
                            {typeof cardBody === 'string' ? parseHTML(cardBody, 'SolidColorPhotoCard') : getReplacedContent(cardBody)}
                        </div>
                    </div>
                    <div className={classNames("footer mt-auto", {"position-relative" : cmsId})}>
                        {typeof cardFooter === 'string' ? parseHTML(cardFooter, 'SolidColorPhotoCard') : getReplacedContent(cardFooter)}
                    </div>
                </div>
        </SolidColorPhotoCardContainer>
    );
};

export default SolidColorPhotoCard;